import { render, staticRenderFns } from "./transaction_volume_stackedbar_by_channel.vue?vue&type=template&id=4d1a7020&"
import script from "./transaction_volume_stackedbar_by_channel.vue?vue&type=script&lang=js&"
export * from "./transaction_volume_stackedbar_by_channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports